<template>
  <div class="partner-container">
    <div class="banner-container">
      <div class="banner-content">
        <div class="banner-title">生态伙伴招募</div>
      </div>
    </div>
    <div class="back-center-panel">
      <div class="back-center" @click="handleJumpPage('OPEN_ABOUTUS_INTRO')">
        <div class="back-icon">
          <div class="back-link">返回关于我们</div>
        </div>
      </div>   
    </div>
    <div class="partner-form-container">
      <div class="partner-form-title">生态伙伴招募申请</div>
      <div class="partner-form">
        <el-form ref="partnerForm" label-position="top" :rules="rules" :model="partnerForm">
          <el-form-item label="公司名称" prop="companyName">
            <el-input v-model="partnerForm.companyName" placeholder="请输入公司名称"></el-input>
          </el-form-item>
          <el-form-item label="联系人姓名" prop="contactName">
            <el-input v-model="partnerForm.contactName" placeholder="请输入您的姓名"></el-input>
          </el-form-item>
          <el-form-item label="职务" prop="position">
            <el-input v-model="partnerForm.position" placeholder="请输入您的职务"></el-input>
          </el-form-item>
          <el-form-item label="手机号" prop="phone" class="inline-item-phone">
            <el-input v-model="partnerForm.phone" placeholder="请输入您的手机号"></el-input>
          </el-form-item>
          <el-form-item label="邮箱" prop="email" class="inline-item-email">
            <el-input v-model="partnerForm.email" placeholder="请输入您的邮箱"></el-input>
          </el-form-item>
          <el-form-item label="意向合作产品" prop="product">
            <el-input v-model="partnerForm.product" placeholder="请填写您要咨询的产品"></el-input>
          </el-form-item>
          <el-form-item label="意向合作地区" prop="region">
            <el-input v-model="partnerForm.region" placeholder="请填写意向合作地区"></el-input>
          </el-form-item>
          <el-form-item label="具体合作内容建议" prop="advice">
            <el-input v-model="partnerForm.advice" type="textarea" maxlength="120" rows=4  placeholder="请填写具体合作内容建议，120字以内"></el-input>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="SendEmail">确认提交</el-button>
          </el-form-item>
        </el-form>
      </div>
    </div>
  </div>
</template>

<script>
import RouteKey from '@/common/RouteKey';

export default {
  name: 'partner',
  data() {
    return {
      partnerForm: {
        companyName: '',
        contactName: '',
        position: '',
        phone: '',
        email: '',
        product: '',
        region: '',
        advice: ''
      },
      rules: {
        companyName: [
          { required: true, message: '请输入公司名称', trigger: ['blur', 'change'] }
          // { min: 2, max: 50, message: '长度在 2 到 50 个字符', trigger: 'blur' }
        ],
        contactName: [
          { required: true, message: '请输入您的姓名', trigger: ['blur', 'change'] }
          // { min: 2, max: 15, message: '长度在 2 到 15 个字符', trigger: 'blur' }
        ],
        position: [
          { required: true, message: '请输入您的职务', trigger: ['blur', 'change'] }
        ],
        phone: [
          { required: true, pattern: /^1[34578]\d{9}$/, message: '请输入您的手机号', trigger: ['blur', 'change'] }
        ],
        email: [
          { required: true, message: '请输入您的邮箱', trigger: 'blur' },
          { type: 'email', message: '请输入正确的邮箱地址', trigger: ['blur', 'change'] }
        ],
        product: [
          { required: true, message: '请填写您要咨询的产品', trigger: ['blur', 'change'] }
        ],
        region: [
          { required: true, message: '请填写意向合作地区', trigger: ['blur', 'change'] }
        ],
        advice: [
          { required: true, message: '请填写具体合作内容建议', trigger: ['blur', 'change'] }
        ]
      }
    };
  },
  methods: {
    SendEmail() {
      this.$refs.partnerForm.validate((valid) => {
        if (valid) {
          const { companyName, contactName, position, phone, email, product, region, advice } = this.partnerForm;
          window.location = `mailto:youtu@tencent.com?subject=生态伙伴招募申请&body=公司名称：${companyName}%0A联系人姓名：${contactName}%0A职务：${position}%0A手机号：${phone}%0A邮箱：${email}%0A意向合作产品：${product}%0A意向合作地区：${region}%0A具体合作内容建议：${advice}`;
        }
      });
    },
    handleJumpPage(url, key) {
      url = RouteKey[url];
      if (key != null) {
        this.$router.transfer(url, {key: key});
        return;
      }
      this.$router.transfer(url);
    }
  }
};
</script>

<style lang="less" scoped>
.partner-container {
  background-color: #ffffff;
  .banner-container{
    width: 100%;
    height: 360px;
    position: relative;
    color: #ffffff;
    background-image: url(./img/banner_aboutus_bg.jpg);
    background-repeat: no-repeat;
    background-position: center center;
    background-size: cover;
    .banner-content{
      width: 1263px;
      margin: 60px auto 0;
      .banner-title{
        font-size: 40px;
        font-family: 'PingFangSC-Medium';
        color: #000000;
        font-weight: 500;
        padding-top: 145px;
        padding-left: 30px;
      }
    }
  }
  .back-center-panel {
    border-bottom: 1px solid #D2D7DF;
    .back-center {
      width: 1263px;
      margin: 0 auto 20px;
      .back-icon{
        width: 200px;
        height: 20px;
        margin-top: 20px;
        margin-left: 30px;
        background: url('../img/arrow_grey_l.svg') left center no-repeat;
        .back-link {
          height: 20px;
          padding-left: 30px;
          line-height: 20px;
          font-size: 14px;
          color: #3D485D;
          opacity: 0.8;
        }
        &:hover {
          cursor: pointer;
          background: url("../img/arrow_normal_l.svg") left center no-repeat;
          .back-link {
            color: #0080FF;
            opacity: 1;
          }
        }
      }
    }
    
  }
  .partner-form-container {
    width: 1263px;
    margin: 0 auto;
    padding: 60px 0 84px;
    .partner-form-title {
      width: 100%;
      height: 42px;
      font-family: 'PingFangSC-Semibold';
      font-size: 28px;
      color: #000000;
      text-align: center;
      line-height: 42px;
      font-weight: 500;
      margin-bottom: 30px;
    }
    .partner-form {
      width: 640px;
      margin-left: 310px;
      font-size: 0;
      .inline-item-phone, .inline-item-email {
        width: 310px;
        display: inline-block;
      }
      .inline-item-email {
        margin-left: 20px;
      }
      /deep/ .el-form-item {
        margin-bottom: 36px;
        .el-form-item__label {
          font-family: 'PingFangSC-Semibold';
          font-size: 16px;
          color: #000000;
          font-weight: 600;
          margin-right: 38px;
          line-height: 34px;
          text-align: left;
          &::before {
            display: none;
          }
          &::after {
            content: '*';
            color: #f56c6c;
            margin-left: 4px;
            vertical-align: middle;
          }
        }
        .el-form-item__error {
          padding-left: 0 !important;
          background: none;
        }
        .el-form-item__content {
          width: 100%;
          .el-form-item__error {
            line-height: 18px;
            padding-top: 10px;
          }
          .el-button {
            width: 200px;
            display: block;
            margin: 30px auto 0;
            border-radius: 0;
            background-color: #0080FF;
            border-color: #0080FF;
          }
        }
        .el-select {
          width: 100%;
        }
      }
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/open/panels/aboutus/panels/Partner.vue